import { SubMenuItemsType } from "@/types/menu";
import { cn } from "@/lib/utils";

export const PlainItem = ({ items }: { items: SubMenuItemsType }) => {
  if (!items?.items || items.items.length === 0) return null;

  return (
    <div>
      {items?.label && (
        <div className="paragraph-sm text-muted-foreground pb-4">{items?.label}</div>
      )}
      <div className="flex flex-col gap-4">
        {items?.items?.map((item,index) => (
          item?.title && (
            <a
              key={index}
              href={item?.link || "/"}
              className="flex items-center gap-1"
            >
              {item?.hasIcon && item?.icon && (
                <span className="material-symbols-outlined w-3.5 h-3.5" style={{ fontSize: '16px' }}>{item?.icon}</span>
              )}
              {item?.title && (
                <span className={cn("paragraph-sm", item?.bold ? "font-bold" : "")}>{item?.title}</span>
              )}
            </a>
          )
        ))}
      </div>
    </div>
  );
};

PlainItem.displayName = 'NavPlainItem'; 